<template>
    <span>{{ date }}</span>
</template>
<script>

import { i18n } from '/vodalys/vvuejs/vue';

export default {
    props: {
        timestamp: Number,
        options: {
            type: Object,
            default: () => {
                return {
                    dateStyle: 'medium',
                }
            }
        },
        multiplicateur: {
            type: Number,
            default: 1_000
        },
        locale: {
            type: String,
            default: 'en-US'
        }
    },
    computed: {
        dateTime() {
            return new Date(this.timestamp * this.multiplicateur)
        },
        date() {
            const options = this.options;
            return this.dateTime.toLocaleDateString(i18n?.locale ?? this.locale, options);
        }
    },
}</script>